const navBar = {
  fr: {
    navBar: {
      logout: 'Déconnexion',
      selectHub: 'Sélectionner un hub',
      selectProject: 'Sélectionner un project',
      feature: 'Fonctionnalité',
      projectWithErrorDescription: 'Projet: {{error}}',
      projectsWithErrorDescription: 'Projets: {{error}}',
      hubWithErrorDescription: 'Hub: {{error}}',
      hubsWithErrorDescription: 'Hubs: {{error}}',
    },
  },
  en: {
    navBar: {
      logout: 'Logout',
      selectHub: 'Select a hub',
      selectProject: 'Select a project',
      feature: 'Feature',
      projectWithErrorDescription: 'Project: {{error}}',
      projectsWithErrorDescription: 'Projects: {{error}}',
      hubWithErrorDescription: 'Hub: {{error}}',
      hubsWithErrorDescription: 'Hubs: {{error}}',
    },
  },
};

export default navBar;
